
import { RevIllustration, RevLink } from '@backmarket/design-system'
import { parse } from 'query-string'

import { MODAL_NAMES } from '@config/constants'
import { productGradesDescriptionFetch } from '@http/endpoints'
import { trackClick } from '@tracking/events'

import Picker from '../../Picker'
import AsyncModal from '../AsyncModal'

import translations from './GradesModal.translations'
import GradeDescription from './components/GradeDescription'

export default {
  components: {
    AsyncModal,
    RevLink,
    RevIllustration,
    GradeDescription,
    Picker,
  },
  props: {
    grades: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      disabledGradeIndex: null,
      gradesDescriptions: [],
    }
  },
  computed: {
    translations: () => translations,
    modalName: () => MODAL_NAMES.PRODUCT.GRADES,
    activeGrade() {
      return this.grades.find((grade) => grade.selected)
    },
    pickers() {
      return this.grades.map(
        ({ backboxGrade, price, selected, isDisabled, id }) => ({
          backboxGrade,
          price,
          id,
          disabled: isDisabled,
          // no picker should be selected if clicking on an out of stock grade picker
          selected: selected && this.disabledGradeIndex === null,
        }),
      )
    },
    description() {
      if (this.disabledGradeIndex !== null) {
        return this.gradesDescriptions[this.disabledGradeIndex]
      }

      return this.gradesDescriptions.find(
        ({ backboxGrade }) =>
          backboxGrade.value === this.activeGrade.backboxGrade.value,
      )
    },
    image() {
      return this.description?.images?.[0] ?? null
    },
    details() {
      return this.description?.paragraphs ?? []
    },
    isDetailsDisabled() {
      return this.disabledGradeIndex !== null
    },
  },
  methods: {
    async fetchGradesDescription() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productGradesDescriptionFetch,
        queryParams: {
          include_technical_comment: true,
        },
        pathParams: { id: this.$route.params.uuid },
      })

      this.gradesDescriptions = payload
    },
    resetDisabledGradeIndex() {
      this.disabledGradeIndex = null
    },
    updateGrade(picker) {
      if (picker.disabled) {
        this.disabledGradeIndex = this.grades.findIndex(
          (grade) => grade.backboxGrade.value === picker.backboxGrade.value,
        )

        return
      }
      // this needs to run before evaluating the line after
      this.disabledGradeIndex = null
      // avoid vue-router redundant navigation warning
      const hash = parse(this.$route.hash)
      const { l } = hash

      if (parseInt(l, 10) === picker.backboxGrade.value) {
        return
      }

      trackClick({
        zone: 'grade_picker_modal',
        name: picker.backboxGrade.value,
        value: {
          listing_id: picker.id && picker.id.toString(),
          price: picker.price && picker.price.amount,
        },
      })

      this.$navigation.replace({
        type: 'internal',
        hash: { l: picker.backboxGrade.value },
      })
    },
    getPickerDescription({ disabled, price }) {
      return disabled ? this.$t(translations.alreadySold) : this.$t.price(price)
    },
  },
}
